// source: pbtypes/vehicle/dock_client/dock_client.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.dock_client.DockVehiclePairing', null, global);
goog.exportSymbol('proto.dock_client.DockVehiclePairing.DockType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dock_client.DockVehiclePairing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dock_client.DockVehiclePairing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dock_client.DockVehiclePairing.displayName = 'proto.dock_client.DockVehiclePairing';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dock_client.DockVehiclePairing.prototype.toObject = function(opt_includeInstance) {
  return proto.dock_client.DockVehiclePairing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dock_client.DockVehiclePairing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dock_client.DockVehiclePairing.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
dockId: jspb.Message.getFieldWithDefault(msg, 2, ""),
vehicleId: jspb.Message.getFieldWithDefault(msg, 3, ""),
vehicleWifiSsid: jspb.Message.getFieldWithDefault(msg, 4, ""),
vehicleWifiPskBytes: msg.getVehicleWifiPskBytes_asB64(),
dockType: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dock_client.DockVehiclePairing}
 */
proto.dock_client.DockVehiclePairing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dock_client.DockVehiclePairing;
  return proto.dock_client.DockVehiclePairing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dock_client.DockVehiclePairing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dock_client.DockVehiclePairing}
 */
proto.dock_client.DockVehiclePairing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDockId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setVehicleId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setVehicleWifiSsid(value);
      break;
    case 5:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setVehicleWifiPskBytes(value);
      break;
    case 6:
      var value = /** @type {!proto.dock_client.DockVehiclePairing.DockType} */ (reader.readEnum());
      msg.setDockType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dock_client.DockVehiclePairing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dock_client.DockVehiclePairing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dock_client.DockVehiclePairing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dock_client.DockVehiclePairing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getDockId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getVehicleId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getVehicleWifiSsid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getVehicleWifiPskBytes_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      5,
      f
    );
  }
  f = message.getDockType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.dock_client.DockVehiclePairing.DockType = {
  UNKNOWN: 0,
  DOCK: 1,
  DOCK_LITE: 2,
  G47: 3,
  G17: 4
};

/**
 * optional int64 utime = 1;
 * @return {number}
 */
proto.dock_client.DockVehiclePairing.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dock_client.DockVehiclePairing} returns this
 */
proto.dock_client.DockVehiclePairing.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string dock_id = 2;
 * @return {string}
 */
proto.dock_client.DockVehiclePairing.prototype.getDockId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dock_client.DockVehiclePairing} returns this
 */
proto.dock_client.DockVehiclePairing.prototype.setDockId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string vehicle_id = 3;
 * @return {string}
 */
proto.dock_client.DockVehiclePairing.prototype.getVehicleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dock_client.DockVehiclePairing} returns this
 */
proto.dock_client.DockVehiclePairing.prototype.setVehicleId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string vehicle_wifi_ssid = 4;
 * @return {string}
 */
proto.dock_client.DockVehiclePairing.prototype.getVehicleWifiSsid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dock_client.DockVehiclePairing} returns this
 */
proto.dock_client.DockVehiclePairing.prototype.setVehicleWifiSsid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bytes vehicle_wifi_psk_bytes = 5;
 * @return {!(string|Uint8Array)}
 */
proto.dock_client.DockVehiclePairing.prototype.getVehicleWifiPskBytes = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * optional bytes vehicle_wifi_psk_bytes = 5;
 * This is a type-conversion wrapper around `getVehicleWifiPskBytes()`
 * @return {string}
 */
proto.dock_client.DockVehiclePairing.prototype.getVehicleWifiPskBytes_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getVehicleWifiPskBytes()));
};


/**
 * optional bytes vehicle_wifi_psk_bytes = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getVehicleWifiPskBytes()`
 * @return {!Uint8Array}
 */
proto.dock_client.DockVehiclePairing.prototype.getVehicleWifiPskBytes_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getVehicleWifiPskBytes()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.dock_client.DockVehiclePairing} returns this
 */
proto.dock_client.DockVehiclePairing.prototype.setVehicleWifiPskBytes = function(value) {
  return jspb.Message.setProto3BytesField(this, 5, value);
};


/**
 * optional DockType dock_type = 6;
 * @return {!proto.dock_client.DockVehiclePairing.DockType}
 */
proto.dock_client.DockVehiclePairing.prototype.getDockType = function() {
  return /** @type {!proto.dock_client.DockVehiclePairing.DockType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.dock_client.DockVehiclePairing.DockType} value
 * @return {!proto.dock_client.DockVehiclePairing} returns this
 */
proto.dock_client.DockVehiclePairing.prototype.setDockType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


goog.object.extend(exports, proto.dock_client);
